import React, { forwardRef } from 'react';
import { Label, RadioWrapper, StyledHelperText } from './Radio.styles';
import { MarginProps } from '../../../theme/styledProps';
import { RadioBase } from './RadioBase/RadioBase';
import { Text } from '../Text/Text';
import { Box } from '../Box/Box';

export interface RadioProps
  extends Omit<React.ComponentPropsWithoutRef<'input'>, 'size'>,
    MarginProps {
  helperText?: string;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ checked, onChange, disabled, children, helperText, ...rest }, ref) => {
    return (
      <RadioWrapper checked={checked} disabled={disabled} {...rest}>
        <Label disabled={disabled}>
          <RadioBase
            ref={ref}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            {...rest}
          />

          <Box display="flex" flexDirection="column">
            <Text fontWeight={500} color="inherit" mt={-2} ml="8">
              {children}
            </Text>

            {helperText && (
              <StyledHelperText disabled={disabled} ml="8" mt="2">
                {helperText}
              </StyledHelperText>
            )}
          </Box>
        </Label>
      </RadioWrapper>
    );
  },
);
